export const routeNames = [
  'Default',
  'Signin',
  'MyAccount',
  'Trips',
  'Workflow',
];
